/* Glambe light motion helpers: header solid on scroll, CTA tap spinner, sticky bar label. */
(function () {
  if (window.__gbMotion) return; window.__gbMotion = 1;
  var h = document.documentElement, on = false, tick = false;
  function s() { tick = false; var v = (window.scrollY || 0) > 24; if (v !== on) { on = v; h.classList.toggle('gm-scrolled', v); } }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(s); } }, { passive: true });
  s();
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gbk-cod');
    if (!b) return; b.classList.add('gm-busy'); setTimeout(function () { b.classList.remove('gm-busy'); }, 700);
  }, true);
  function lab() {
    document.querySelectorAll('[data-satc]').forEach(function (b) {
      if (b.__gbl) return; var t = (b.textContent || '').trim();
      if (/add to cart/i.test(t)) { b.__gbl = 1; b.textContent = 'Order now · Cash on delivery'; }
    });
  }
  lab(); document.addEventListener('DOMContentLoaded', lab); window.addEventListener('load', lab); setTimeout(lab, 1500);
})();
